export const validClock = value => typeof value==='string' && /^([01]\d|2[0-3]):[0-5]\d$/.test(value);
// A time of day is a wall-clock value, not a UTC instant. Use a fixed winter
// date so today's daylight-saving transition cannot normalize a selected hour.
export function clockDate(value) {
  const [hour,minute]=(validClock(value)?value:'09:00').split(':').map(Number);
  return new Date(2020,0,15,hour,minute,0,0);
}
export function clockValue(date) {
  if(!(date instanceof Date)||!Number.isFinite(date.getTime()))return null;
  return `${String(date.getHours()).padStart(2,'0')}:${String(date.getMinutes()).padStart(2,'0')}`;
}
